import { Component, OnInit } from '@angular/core';
import {FormControl} from '@angular/forms';
import {SEARCH_TYPE_CUENTA, SearchService} from '@services/search-service';
import {Observable} from 'rxjs/Observable';
import {MdDialogRef} from '@angular/material';

@Component({
  selector: 'app-remitos-cli-selector-dialog',
  templateUrl: './remitos-cli-selector-dialog.component.html',
  styleUrls: ['./remitos-cli-selector-dialog.component.scss', '../remitos-common-styles.scss']
})
export class RemitosCliSelectorDialogComponent implements OnInit {

  public cuentas = [];
  public cuentasStateControl: FormControl;
  public filteredCuentas: Observable<any>;
  public selectedCuentas = [];

  constructor(
    private searchService: SearchService,
    public dialogRef: MdDialogRef<RemitosCliSelectorDialogComponent>
  ) {
    // Cuentas
    this.cuentasStateControl = new FormControl();
    this.filteredCuentas = this.cuentasStateControl.valueChanges
      .startWith(null)
      .debounceTime(1000)
      .switchMap(value => {
        if (value && value.length > 2){
          return this.searchService.searchAutocomplete(value, SEARCH_TYPE_CUENTA);
        } else {
          return Observable.from([]);
        }
      })
      .map( value => {
        value.forEach(emp => {
          if (emp.CuentaAcopio) {
            emp.cuentasAcopios = '';
            emp.CuentaAcopio.forEach(e => {
              if (e.CuentaAcopio !== 0) {
                emp.cuentasAcopios += e.CuentaAcopio.toString() + ', ';
              }
            });
            if (emp.cuentasAcopios.length) {
              emp.cuentasAcopios = emp.cuentasAcopios.slice(0, -2);
            }
          }
        });
        return value;
      });
  }

  ngOnInit() {
  }

  selectedCuenta($event, cuenta) {
    this.dialogRef.close(cuenta);
  }

}



// WEBPACK FOOTER //
// E:/jenkins_home/workspace/_agenda-unco-front-legacy_master/frontend-web/src/app/components/administracion/remitos/common/remitos-cli-selector-dialog/remitos-cli-selector-dialog.component.ts